import { OilGasHeader } from "@/components/chevron/OilGasHeader";
import { DomainSection } from "@/components/chevron/DomainSection";
import { upstreamDomains } from "@/data/chevron/upstreamDomains";
import { midstreamDomains } from "@/data/chevron/midstreamDomains";
import { downstreamDomains } from "@/data/chevron/downstreamDomains";
import Navbar from "@/components/Navbar";
import { Card, CardContent } from "@/components/ui/card";
import KnowledgeNetworkStats from "@/components/shared/KnowledgeNetworkStats";
import TeamMembersGrid from "@/components/ispai/TeamMembersGrid";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InviteColleagueDialog } from "@/components/InviteColleagueDialog";
const oilGasTeamMembers = [
  {
    image: "/placeholder.svg",
    alt: "Trey Fleming"
  },
  {
    image: "/placeholder.svg",
    alt: "Karen Watson"
  },
  {
    image: "/placeholder.svg",
    alt: "Corey Vickers"
  },
  {
    image: "/placeholder.svg",
    alt: "Enrique Barrantes"
  },
  {
    image: "/placeholder.svg",
    alt: "Jim Lawnin"
  },
  {
    image: "/placeholder.svg",
    alt: "Morgan Eldred"
  },
  {
    image: "/placeholder.svg",
    alt: "Chris Clayton"
  },
  {
    image: "/placeholder.svg",
    alt: "Louie Ehrlich"
  },
  {
    image: "/placeholder.svg",
    alt: "Ed Barrows"
  }
];

const networkStats = {
  totalParticipants: 1625,
  activeContributors: 824,
  knowledgeBases: 1378,
  totalSolutions: 10,
  departments: [{
    name: "Upstream Operations",
    participants: 487
  }, {
    name: "Midstream Operations",
    participants: 342
  }, {
    name: "Downstream Operations",
    participants: 376
  }, {
    name: "Research & Development",
    participants: 245
  }, {
    name: "Corporate Strategy",
    participants: 175
  }]
};
const OilGasChannel = () => {
  const navigate = useNavigate();
  const [inviteDialogOpen, setInviteDialogOpen] = useState(false);
  
  // Fetch knowledge bases with domain associations
  const { data: domainKBs } = useQuery({
    queryKey: ['oilgas-channel-kbs'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('knowledge_base_domains')
        .select(`
          knowledge_base_id,
          domain_id,
          domains(name, symbol),
          knowledge_bases!inner(
            id,
            title,
            status,
            deleted_at,
            creator_id
          )
        `)
        .eq('knowledge_bases.status', 'published')
        .is('knowledge_bases.deleted_at', null);
      
      if (error) throw error;
      return data;
    }
  });

  return <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <OilGasHeader />
        
        <TeamMembersGrid 
          members={oilGasTeamMembers} 
          useProfileAvatars={true}
          showAskCurt={false}
        />

        <Card className="mb-12 p-6">
          <CardContent className="p-0">
            <h2 className="text-xl font-semibold mb-4">Dashboard</h2>
            <KnowledgeNetworkStats {...networkStats} channelName="oil-gas" />
          </CardContent>
        </Card>
        
        <DomainSection title="Upstream" domains={upstreamDomains} titleColor="text-primary" domainKBs={domainKBs} />
        <DomainSection title="Midstream" domains={midstreamDomains} titleColor="text-primary" domainKBs={domainKBs} />
        <DomainSection title="Downstream" domains={downstreamDomains} titleColor="text-primary" domainKBs={domainKBs} />

        <div className="mt-12 mb-8">
          <h2 className="text-xl font-semibold mb-6 text-primary">Industry Templates</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <a 
              href="https://img1.wsimg.com/blobby/go/70e764c8-c764-4e83-ada3-5ccb3a393f3d/downloads/iSPAI%20Industry_Energy%20(Oil%20%26%20Gas%20Upstream).pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer transform transition-transform hover:scale-105 block"
            >
              <img 
                src="/lovable-uploads/397b0ddb-8ad5-4ffc-a650-774f31c86b5c.png" 
                alt="Oil & Gas Upstream Industry Template" 
                className="w-full h-auto rounded-lg shadow-lg border border-gray-200"
              />
            </a>
            <a 
              href="https://img1.wsimg.com/blobby/go/70e764c8-c764-4e83-ada3-5ccb3a393f3d/downloads/iSPAI%20Industry_Energy%20(Oil%20%26%20Gas%20Midstream).pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer transform transition-transform hover:scale-105 block"
            >
              <img 
                src="/lovable-uploads/e0657573-c0af-47d4-bab2-e94e8b26dd74.png" 
                alt="Oil & Gas Midstream Industry Template" 
                className="w-full h-auto rounded-lg shadow-lg border border-gray-200"
              />
            </a>
            <a 
              href="https://img1.wsimg.com/blobby/go/70e764c8-c764-4e83-ada3-5ccb3a393f3d/downloads/iSPAI%20Industry_Energy%20(Oil%20%26%20Gas%20Downstream).pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="cursor-pointer transform transition-transform hover:scale-105 block"
            >
              <img 
                src="/lovable-uploads/a8088ed6-498a-4151-ac78-9dead710b3fd.png" 
                alt="Oil & Gas Downstream Industry Template" 
                className="w-full h-auto rounded-lg shadow-lg border border-gray-200"
              />
            </a>
          </div>
        </div>
        
        {/* Invite Dialog */}
        <InviteColleagueDialog
          open={inviteDialogOpen}
          onOpenChange={setInviteDialogOpen}
          channelId="69d024ae-f179-40d9-9ac5-88aaf46ce866"
          channelName="Oil and Gas Channel"
        />
      </div>
    </div>;
};
export default OilGasChannel;
